import {
  DEFAULT_WEBSTUDIO_API_BASE_URL,
  configuredWebstudioApiBaseUrl,
} from './webstudio-api';

const DEFAULT_VERSION_API_MAX_ATTEMPTS = 2;
const DEFAULT_VERSION_API_TIMEOUT_MS = 15000;
const VERSION_API_RETRY_DELAY_MS = 500;
const VERSION_API_PATH = '/api/version/';

function configuredVersionApiBaseUrl(): string {
  return configuredWebstudioApiBaseUrl('NEXT_PUBLIC_VERSION_API_BASE_URL');
}

export function versionApiUrl(): string {
  try {
    return new URL(VERSION_API_PATH, configuredVersionApiBaseUrl()).toString();
  } catch {
    return new URL(VERSION_API_PATH, DEFAULT_WEBSTUDIO_API_BASE_URL).toString();
  }
}

function configuredPositiveInteger(
  envName: 'NEXT_PUBLIC_VERSION_API_TIMEOUT_MS',
  fallback: number,
): number {
  const raw = process.env[envName]?.trim();
  if (!raw) return fallback;
  const parsed = Number.parseInt(raw, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async function fetchWithTimeout(url: string, init?: RequestInit): Promise<Response> {
  const timeoutMs = configuredPositiveInteger(
    'NEXT_PUBLIC_VERSION_API_TIMEOUT_MS',
    DEFAULT_VERSION_API_TIMEOUT_MS,
  );
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), timeoutMs);
  try {
    return await fetch(url, {
      ...init,
      signal: controller.signal,
    });
  } finally {
    clearTimeout(timeout);
  }
}

export async function fetchVersionApi(init?: RequestInit): Promise<Response> {
  let lastError: unknown;
  for (let attempt = 0; attempt < DEFAULT_VERSION_API_MAX_ATTEMPTS; attempt += 1) {
    try {
      return await fetchWithTimeout(versionApiUrl(), init);
    } catch (err) {
      lastError = err;
      if (attempt < DEFAULT_VERSION_API_MAX_ATTEMPTS - 1) {
        await delay(VERSION_API_RETRY_DELAY_MS);
      }
    }
  }
  throw lastError;
}
